import { render, staticRenderFns } from "./IPWhitelist.vue?vue&type=template&id=7fa71df2"
import script from "./IPWhitelist.vue?vue&type=script&lang=js"
export * from "./IPWhitelist.vue?vue&type=script&lang=js"
import style0 from "./IPWhitelist.vue?vue&type=style&index=0&id=7fa71df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports